import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
} from "@mui/material";
import CustomButton from "../../ui/button/Button";
import { useState, useEffect } from "react";
import { getTiposCalculoProgreso } from "../../components/functions/Projects";
import SelectAutoComplete from "../../ui/selectAutoComplete/SelectAutoComplete";

const CalculoProgresoModal = ({ open, onClose, onConfirm, API_URL }) => {
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [tipo, setTipo] = useState(null);
  const [progreso, setProgreso] = useState(0);
  const [tipos, setTipos] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const tiposRes = await getTiposCalculoProgreso(API_URL);
      setTipos(tiposRes);
    };

    if (open) {
      fetchData();
    }
  }, [open]);

  const handleClose = () => {
    onClose();
    setTipo(null);
    setProgreso(0);
  };

  const handleConfirm = () => {
    if (!tipo) {
      setShowSnackbar(true);
      setSnackbarMessage("Seleccione un tipo de cálculo de progreso.");
      return;
    }
    onConfirm(tipo, progreso);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          setSnackbarMessage("");
        }}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          content: {
            sx: {
              backgroundColor: "white",
              color: "#222",
              justifyContent: "center",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: "Roboto, Arial, sans-serif",
            },
          },
        }}
      />
      <DialogTitle>Establecer tipo de cálculo de progreso</DialogTitle>
      <DialogContent>
        <div style={{ height: "120px", padding: "8px 0" }}>
          <SelectAutoComplete
            label="Tipo de cálculo de progreso"
            fieldC="name"
            options={tipos}
            value={tipo}
            onChange={(e, value) => setTipo(value)}
            placeholder="Seleccionar..."
            size="small"
            width={"100%"}
          />
          {tipo?.esManual && (
            <>
              <label className="form-label" style={{ marginTop: "12px" }}>
                Progreso:
              </label>
              <input
                className="form-input"
                type="number"
                min={0}
                max={100}
                placeholder="Progreso..."
                value={progreso}
                onChange={(e) => {
                  if (e.target.value >= 0 && e.target.value <= 100) {
                    setProgreso(e.target.value);
                  }
                  if (e.target.value > 100) {
                    setProgreso(100);
                  }
                  if (e.target.value < 0) {
                    setProgreso(0);
                  }
                }}
              />
            </>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton
          background={"#FFFFFF"}
          color={"#223D51"}
          text="Cancelar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={handleClose}
        />
        <CustomButton
          background={"#223D51"}
          color={"#FFFFFF"}
          text="Guardar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          onClick={handleConfirm}
          type="button"
          width={"100px"}
        />
      </DialogActions>
    </Dialog>
  );
};

export default CalculoProgresoModal;
